export default {
    BusinessThirdOrderAdd: {
        Basic: 'Account Information of third-party orders',
        Third: 'Customer Order No.',
        Ordertype: 'Order Type',
        Selectchannel: 'Select channel',
        Selectstore: 'Select store',
        Selectsales: 'Select sales staff',
        Pleaseselect: 'Please select',
        Pleasestore: 'Please Select a store first',
        picking: 'Select pick-up store',
        Tripartite: '3rd Party Order Time',
        Freight: 'Shipping cost',
        Merchant: "Merchant's Comments",
        Buyer: 'Buyer and consignee information',
        Delivery: 'Pick-up method',
        nickname: 'Buyer nickname',
        Consignee: 'Consignee name',
        mobile: 'Buyer phone number',
        phone: 'Consignee phone number',
        Shipping: 'Shipping address',
        Detailed: 'Detailed address',
        comments: 'Buyer Comments',
        Payment: 'Payment information',
        method: 'Payment method',
        document: 'Payment Order No.',
        amount: 'Payment amount',
        status: 'Payment status',
        time: 'Payment time',
        information: 'Product Information',
        Add: 'Add product',
        Freights: 'Shipping cost',
        Totalgoods: 'Total amount of goods',
        Totalamount: 'Total discount',
        Totalreceivable: 'Total amount receivable',
        Totalactually: 'Total amount paid by buyer',
        common: 'Add Product',
        package: 'Add package product',
        province: 'Please select province/city/district',
        detailedaddress: 'Please enter detailed address',
        channel: 'Please select channel',
        store: 'Please select store',
        order: 'Please enter Customer Order No.',
        ordering: 'Please select third-party order time',
        type: 'Please select order type',
        thenickname: 'Please enter buyer nickname',
        thename: 'Please enter consignee name',
        your: 'Please enter mobile number',
        Pleasemethod: 'Please select payment method',
        Pleaseamount: 'Please enter payment amount',
        Pleasepayment: 'Please select payment status',
        selecttime: 'Please select payment time',
        pickupstore: 'Please select pick-up store',
        amethod: 'Please select pick-up method',
        sure: 'Confirm deletion',
        Deletion: 'Deletion successful',
        cannot: 'Payment time cannot be earlier than order time',
        sales: 'Total third-party platform sales price must match payment amount!',
        Submitted: 'Submission successful',
        deliveryAppointmentTime: 'Delivery Appointment Time',
        physicalWarehouseNotFound: 'Physical warehouse not found. Please check the warehouse configuration.',
        form: {
            Product: 'Product name',
            code: 'Product code',
            SKU: 'SKU',
            Quantity: 'Quantity',
            Giveaway: 'Is it a gift',
            Unit: 'Unit price of the product',
            Total: 'Total product amount',
            Merchant: 'Merchant bears the discount amount',
            The: 'Third party bears the discount amount',
            Operation: 'Action',
        }
    }
};
